

export const ROUTES = {
  home: {
    root: '/',
  },
  contact: {
    root: '/contacto',
  },
  aboutUs: {
    root: '/nosotros',
  },
  workWithUs: {
    root: '/trabaja-con-nosotros',
  },
  literature: {
    root: '/literatura',
    categories: (categorySlug: string) => `/literatura/${categorySlug}`,
    details: (categorySlug: string, literatureSlug: string) => `/literatura/${categorySlug}/${literatureSlug}`,
  },
  usedEquipmentsCertificate: {
    root: '/equipos-usados-certificados'
  },
  promotions: {
    root: '/promociones',
    details: (slug: string) => `/promociones/${slug}`
  },
  industries: {
    root: '/industrias',
    details: (slug: string) => `/industrias/${slug}`,
  },
  usedEquipments: {
    root: '/equipos-usados',
    details: (slug: string) => `/equipos-usados/${slug}`,
    used: (slug: string) => `/equipos-usados/usado/${slug}`
  },
  rentals: {
    root: '/rentas',
    categories: (slug: string) => `/rentas/${slug}`
  },
  technologySolutions: {
    root: '/soluciones-tecnologicas',
    details: (slug: string) => `/soluciones-tecnologicas/${slug}`,
    miningTechnology: 'tecnologia-para-mineria',
    industrialWirelessNetworks: 'redes-inambricas-industriales',
    static:{
      catMinestarTechnicalSupport: 'soporte-tecnico-cat-minestar',
      catMinestarConsulting: 'consultoria-cat-minestar',
      catMinestarTraining: 'capacitaciones-cat-minestar',
      catCard: 'cat-card',
      technicalSupport: 'soporte-tecnico',
      consulting: 'servicios-de-consultorias',
      training: 'capacitaciones-y-entrenamientos',
    }
  },
  partsServices: {
    root: '/refacciones-y-servicios',
    details: (slug: string) => `/refacciones-y-servicios/${slug}`
  },
  partsServicesSubcategories: {
    details: (slugCategory: string, slugSubcategory: string) => `/refacciones-y-servicios/${slugCategory}/${slugSubcategory}`,
    visionLink: '/refacciones-y-servicios/soluciones-digitales-cat/visionlink/',
    sis2go: '/refacciones-y-servicios/soluciones-digitales-cat/cat-sis2go/',
    catApp: '/refacciones-y-servicios/soluciones-digitales-cat/cat-central-app/',
    static:{
      digitalSolutions: 'soluciones-digitales-cat',
      originalParts: 'refacciones',
      catCentral:'cat-central-app',
      sis2go: 'cat-sis2go',
      codigoQRCat: 'codigos-qr-cat',
      visionLink: 'visionlink',
    }
  },
  tires: {
    root: '/llantas',
    industries: (industrySlug: string) => `/llantas/${industrySlug}`,
    details: (industrySlug: string, tireSlug: string) => `/llantas/${industrySlug}/${tireSlug}`
  },
  products: {
    root: '/productos-nuevos',
    industry: (industrySlug: string | undefined) => `/productos-nuevos/${industrySlug}`,
    family: (industrySlug: string | undefined, familySlug: string | undefined) => `/productos-nuevos/${industrySlug}/${familySlug}`,
    subfamily: (industrySlug: string | undefined, familySlug: string | undefined, subfamilySlug: string | undefined) => `/productos-nuevos/${industrySlug}/${familySlug}/${subfamilySlug}`,
    productDetails: (productSlug: string, industrySlug: string | undefined) => !industrySlug ? `/producto-nuevo/${productSlug}` : `/producto-nuevo/${productSlug}/?industria=${industrySlug}`,
  },
  news: {
    root: '/noticias',
    categories: (categorySlug: string) => `/noticias/${categorySlug}`,
    details: (categorySlug: string, newsSlug: string) => `/noticias/${categorySlug}/${newsSlug}`,
  },
  brands: {
    root: '/productos-por-marca',
    brand: (brandSlug: string | undefined) => `/productos-por-marca/${brandSlug}`,
    industry: (brandSlug: string | undefined, industrySlug: string | undefined) => `/productos-por-marca/${brandSlug}/${industrySlug}`,
    family: (brandSlug: string | undefined, industrySlug: string | undefined, familySlug: string | undefined) => `/productos-por-marca/${brandSlug}/${industrySlug}/${familySlug}`,
    subfamily: (brandSlug: string | undefined, industrySlug: string | undefined, familySlug: string | undefined, subfamilySlug: string | undefined) => `/productos-por-marca/${brandSlug}/${industrySlug}/${familySlug}/${subfamilySlug}`
  },
  branches: {
    root: '/sucursales',
    branch: (typeSlug: string, branchSlug: string) => `/sucursales/${typeSlug}/${branchSlug}`,
    googleHowToGo:  (latitude: number, length: number) => `https://www.google.com/maps?q=${latitude},${length}`, 
    google: (latitude: number, length: number) => `https://www.google.com/maps?q=${latitude},${length}&hl=es;z=14&output=embed`,
  },
  external: {
    constructionTechnology: 'https://www.sitechnoroeste.com.mx/',
    googlePlayStore: 'https://play.google.com/store/apps/details?id=com.cat.digital.mobile.sis2go&hl=es',
    appleStore: 'https://apps.apple.com/es/app/cat-sis2go/id1528609895',
    microsoftStore: 'https://apps.microsoft.com/detail/9n6svzr1lfvc?hl=es-mx&gl=MX',
    visionLink: 'https://vl.cat.com/es-ES',
    si2go: 'https://sis2.cat.com/#',
    partsMatco: 'https://parts.cat.com/es/matco',
    mycatFinancial: 'https://mycatfinancial.com/s/apply?language=es_MX',
    usedParts: 'https://parts.cat.com/es/matco',
    discounts: 'https://www.cat.com/es_MX/promotions/finance/cat-card-offers.html',
    credits: 'https://www.cat.com/es_MX/support/cat-credits.html',
    loginFinancial: 'https://mycatfinancial.com/GC_Login?ec=302&startURL=%2Fs%2F',
    solicitude: 'https://mycatfinancial.com/s/apply?language=es_MX',
    naturalPerson: 'https://s7d2.scene7.com/is/content/Caterpillar/CM20241119-4b4c1-d5066',
    moralPerson: 'https://s7d2.scene7.com/is/content/Caterpillar/CM20241119-10386-0a148',
    anex: 'https://www.cat.com/es_MX/support/financing-protection/financing-options/cat-card.html#accordion-e24cb58184-item-9cc67dcb6b-button',
    formationBC: 'https://s7d2.scene7.com/is/content/Caterpillar/CM20241119-cc601-a40b5',
    formationGeneralData: 'https://s7d2.scene7.com/is/content/Caterpillar/CM20241119-bdff0-92e47',
    termsCat: 'https://www.cat.com/es_MX/support/financing-protection/financing-options/cat-card/agreement.html',
  }
} as const